/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdvancedSearchCreatedResponse
 */
export interface AdvancedSearchCreatedResponse {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchCreatedResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchCreatedResponse
     */
    briefId: string;
}

/**
 * Check if a given object implements the AdvancedSearchCreatedResponse interface.
 */
export function instanceOfAdvancedSearchCreatedResponse(value: object): value is AdvancedSearchCreatedResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('briefId' in value) || value['briefId'] === undefined) return false;
    return true;
}

export function AdvancedSearchCreatedResponseFromJSON(json: any): AdvancedSearchCreatedResponse {
    return AdvancedSearchCreatedResponseFromJSONTyped(json, false);
}

export function AdvancedSearchCreatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchCreatedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'briefId': json['briefId'],
    };
}

export function AdvancedSearchCreatedResponseToJSON(value?: AdvancedSearchCreatedResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'briefId': value['briefId'],
    };
}

